// @flow
import type { FluxStandardAction } from 'fc-flow-types/redux'

export default function createActionCreator<P, M, E> (type: string): (
  payload?: P, meta?: ?M, error?: ?E
  //
) => FluxStandardAction<P, M, E> {
  return function (payload?: P, meta?: ?M, error?: ?E): FluxStandardAction<P, M, E> {
    return {
      type,
      payload,
      meta,
      error,
    }
  }
}
